import { injectable } from 'inversify';
import 'reflect-metadata';
import axiosClient from './axios-client';
import { ERRORS } from '../constants/errors/error-messages.constants';
import { Category } from '../_api/models/categories.model';
import { ApiResponse } from '../utils/api-response.utils';

@injectable()
export class CategoryService {
  async getCategoriesWithSubCategories(): Promise<ApiResponse<Category[]>> {
    try {
      const response =
        await axiosClient.get<ApiResponse<Category[]>>('/api/category');

      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }
}
